<template lang="pug">
.cart-frame(style="width: 500px")
  .cart-header.px-5.py-4
    pr-subtitle {{ $t("Shopping Cart") }}
  .cart-body.py-4.border-top.position-relative
    .cart-list.inset.overflow-hidden.px-3.py-3(ref="scroller", data-offsety="-50")
      .scroll-container.position-relative
        .cart-item.surface-bg-darker.px-4.py-3.align-items-center.mb-1(v-for="item in cart", :key="item.code")
          .title {{ item.title }}
          pr-count.mx-3(text, :value.sync="item.count", small)
          .trash.colored.text-muted(v-nv, @nv-enter="remove(item.code)")
            i.fal.fa-trash
  .cart-footer.border-top
    .balance.d-flex.surface-bg-darker.px-5.py-3.border-bottom
      .title.flex-grow-1 {{ $t("Total Amount") }}
      .value.font-weight-bold {{ $currency(totalBalance) }}
    .actions.px-5.py-4.d-flex.justify-content-between
      pr-button.themed.m-0(v-nv.current, @nv-enter="checkout") {{ $t("Checkout") }}
      pr-button.themed.m-0(v-nv, @nv-enter="$emit('close')") {{ $t("Close") }}
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "cart",
  computed: {
    totalBalance() {
      return this.cart.map(item => item.count * item.price).reduce((accumulator, value) => accumulator + value, 0)
    },
    ...mapGetters("services", ["cart"])
  },
  watch: {
    cart(nval) {
      if (!nval.length) this.$emit("close")
    }
  },
  async mounted() {
    this.$emit("ready")
    _$.nav.sync("sideload", true)

    document.addEventListener("keydown", this.scroll)
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.scroll)
  },
  methods: {
    scroll(e) {
      if (!_$.nav.currentScopeName("sideload")) return

      const eventName = _$.nav.getEventName(e),
        target = _$.nav.getCurrentElement()

      if (!["up", "down"].includes(eventName)) return
      _$.nav.scroll({ element: this.$refs.scroller }, target)
    },
    async checkout() {
      const res = await __.order.send(__.order.template)
      if (res === true) this.$toast({ element: "top-end", theme: "success", content: this.$t("cartThankyou") })
      else if (res) return this.$toast({ element: "top-end", theme: "danger", content: res })
      else if (!res) return this.$toast({ element: "top-end", theme: "danger", content: this.$t("Something went wrong.") })

      __.order.clear()
      this.$emit("close")
      return true
    },
    remove(item) {
      _$.nav.move("down")
      __.order.remove(item)
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.cart-body {
  flex: 1 0 auto;

  .cart-list {
    display: flex;
    flex-direction: column;

    .cart-item {
      display: flex;

      &:first-child {
        border-top: 0 !important;
      }

      .title {
        flex-grow: 1;
      }
    }
  }
}

.nv-el-current {
  i {
    font-weight: 600;
  }
}
</style>
